(() => {
  if (customElements.get('stamp-before-after')) return;
  customElements.define('stamp-before-after', class extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('[data-compare-range]');
      if (!this.slider) return;
      this.update = () => {
        const position = Math.max(0, Math.min(100, Number(this.slider.value)));
        this.style.setProperty('--compare-position', position + '%');
        this.slider.setAttribute('aria-valuetext', position + '% before, ' + (100 - position) + '% after');
      };
      this.slider.hidden = false;
      this.slider.addEventListener('input', this.update);
      this.update();
    }
    disconnectedCallback() { this.slider?.removeEventListener('input', this.update); }
  });
})();